import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'ウィジェット',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 3,
  staffOnly: true,
  listed: true,
};
